import React, { FC, useEffect, useState } from 'react'
import './HealthUpdate.scss'

import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import profileService from 'Services/profileService'
import Swal from 'sweetalert2'

const relationships = [
  'Father',
  'Mother',
  'Brother',
  'Sister',
  'Spouse',
  'Partner',
  'Uncle',
  'Aunt',
  'Cousin',
  'Friend',
  'Guardian',
  'Other',
]

interface propsType {
  toggleModal: () => void
  health: any
  setHealth: any
  selectedHealth: any
  editingIndex: any
}

export type HealthUpdate = {
  fullName: string
  relationship: string
  dob: string
  phone: string
  email: string
}

const schema = yup.object().shape({
  fullName: yup.string().required('Field is required'),
  relationship: yup.string().required('Field is required'),
  dob: yup.string().required('Field is required'),
  phone: yup.string().required('Field is required'),
  email: yup.string().required('Field is required'),
})

const HealthUpdate: FC<propsType> = ({
  toggleModal,
  health,
  setHealth,
  selectedHealth,
  editingIndex,
}) => {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<HealthUpdate>({
    resolver: yupResolver(schema),
  })

  const { showAlert } = ShowTGAlert()
  const [request, setRequest] = useState(false)

  useEffect(() => {
    if (selectedHealth) {
      reset({
        fullName: selectedHealth.fullName,
        relationship: selectedHealth.relationship,
        dob: selectedHealth.dob,
        phone: selectedHealth.phone,
        email: selectedHealth.email,
      })
    } else {
      reset({
        fullName: '',
        relationship: '',
        dob: '',
        phone: '',
        email: '',
      })
    }
  }, [selectedHealth, reset])

  const submitNewUserInformation = handleSubmit(async (data: HealthUpdate) => {
    const formatted = {
      fullName: data.fullName,
      relationship: data.relationship,
      dob: data.dob,
      phone: data.phone,
      email: data.email,
    }

    if (editingIndex !== null) {
      setHealth((prev: any) =>
        prev.map((item: any, i: any) => (i === editingIndex ? formatted : item)),
      )
    } else {
      setHealth((prev: any) => [...prev, formatted])
    }

    toggleModal()
    // await employeeService.createNew(data).then(
    //   () => {
    //     setRequest(false)
    //     toggleModal()
    //     showAlert({
    //       message: 'Pension Details updated successfully',
    //       show: true,
    //       title: 'Success',
    //       type: 'success',
    //     })
    //     setTimeout(() => {
    //       window.location.reload()
    //     }, 200)
    //   },
    //   (error: { response: { data: { error: string } } }) => {
    //     setRequest(false)
    //     toggleModal()
    //     showAlert({
    //       message: error.response.data.error,
    //       show: true,
    //       title: 'Error',
    //       type: 'error',
    //     })
    //   },
    // )
  })
  return (
    <div className='health-update'>
      <form onSubmit={submitNewUserInformation}>
        <div className='form-group'>
          <label htmlFor='fullName' className=''>
            Full Name
          </label>
          <input
            autoComplete='off'
            type='text'
            id='fullName'
            className={`form-control ${errors.fullName ? 'is-invalid' : ''}`}
            {...register('fullName', {})}
          />
          {errors.fullName && <div className='invalid-feedback'>{errors.fullName.message}</div>}
        </div>

        {/* Department */}
        <div className='form-group mt-3'>
          <label htmlFor='relationship' className=''>
            Relationship
          </label>

          <select
            id='relationship'
            className={`form-control ${errors.relationship ? 'is-invalid' : ''}`}
            {...register('relationship', {})}
          >
            <option value=''>Select relationship</option>

            {relationships.map((rel) => (
              <option key={rel} value={rel}>
                {rel}
              </option>
            ))}
          </select>

          {errors.relationship && (
            <div className='invalid-feedback d-block'>{errors.relationship.message}</div>
          )}
        </div>

        <div className='form-group mt-3'>
          <div className='formLine'>
            <label htmlFor='dob' className=''>
              Date of Birth
            </label>

            <input
              type='date'
              id='dob'
              className={`form-control ${errors.dob ? 'is-invalid' : ''}`}
              {...register('dob', {})}
            />

            {errors.dob && <div className='invalid-feedback'>{errors.dob.message}</div>}
          </div>
        </div>

        <div className='form-group mt-3'>
          <div className='formLine'>
            <label htmlFor='phone' className=''>
              Phone Number
            </label>

            <input
              autoComplete='off'
              type='text'
              id='phone'
              className={`form-control custom-select ${errors.phone ? 'is-invalid' : ''}`}
              {...register('phone', {})}
            />
            {errors.phone && <div className='invalid-feedback'>{errors.phone.message}</div>}
          </div>
        </div>

        <div className='form-group mt-3'>
          <div className='formLine'>
            <label htmlFor='email' className=''>
              Email
            </label>

            <input
              autoComplete='off'
              type='text'
              id='email'
              className={`form-control custom-select ${errors.email ? 'is-invalid' : ''}`}
              {...register('email')}
            />
            {errors.email && <div className='invalid-feedback'>{errors.email.message}</div>}
          </div>
        </div>

        <div className='form-group mt-4'>
          <button
            className='btn btn-default-2 w-100'
            // onClick={(e) => submitNewUserInformation(e)}
            disabled={request}
          >
            Save Details {request && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </form>
    </div>
  )
}

export default HealthUpdate
